import Controller from '../abstracts/Controller';

export default class StoreLocatorDetailController extends Controller {

  static get COMPONENTS() {
    return ["StoreLocatorDetailComponent", "PrintComponent", "DatePickerComponent"];
  }
}
